// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__18wTe","content":"RecentSearches_content__1JZdb"};